import { ErrorBoundary } from 'components/common/error-boundary';
import { SessionHistory } from 'components/sections/analytics/session-history';
import { AnalyticsSessionHits } from 'components/sections/analytics/session-hits';
import { SessionHitsSummaries } from 'components/sections/analytics/session-hits-summaries';
import { AnalyticsSessionHitsNew } from 'components/sections/analytics/session-hits/index-new';
import { FF_NAME_ANALYTICS_2 } from 'enums/session-recap/enums';
import { useFeatureFlag } from 'hooks/useFeatureFlag';
import { Navigate, Route, Routes } from 'react-router-dom';
import { paths, routePaths } from 'routes/paths';

const RedirectToIndex = () => (
  <Navigate to={paths.analytics.hittingReports} replace />
);

export const AnalyticsRouter = () => {
  const showNewAnalytics = useFeatureFlag(FF_NAME_ANALYTICS_2);

  return (
    <ErrorBoundary identifier="AnalyticsRouter">
      <Routes>
        <Route path="" element={<RedirectToIndex />} />
        <Route
          path={routePaths.analytics.hittingReports}
          element={<SessionHitsSummaries />}
        />
        <Route
          path={routePaths.analytics.hitterSession}
          element={
            showNewAnalytics ? (
              <AnalyticsSessionHitsNew />
            ) : (
              <AnalyticsSessionHits identifier="AnalyticsHitterSession" />
            )
          }
        />
        <Route
          path={routePaths.analytics.sessionHistory}
          element={<SessionHistory />}
        />
        <Route path="*" element={<RedirectToIndex />} />
      </Routes>
    </ErrorBoundary>
  );
};
